import Image from "next/legacy/image";
import React from "react";
import { BASE_URL } from "../../utils/FetchData";

export default function Promise({ promise,active,index }) {
    const variableBGCode = "#004D44";
    return (
        <div
            className={`amenity promise
            ${active==index ? "active" : ""}
            `}
        >
            <div className="icon-container">
                {promise && <Image
                    src={`${BASE_URL}${promise.icon.data.attributes?.url}`}
                    layout="fill"
                    objectFit="contain"
                    alt={promise.icon.data.attributes?.name}
                />}
            </div>
            <div className="amenity-info">
                <h4 className="title">{promise.title}</h4>
            </div>
            <div className="one"></div>
            <div className="one two"></div>
            <div className="one three"></div>
            <div className="one four"></div>
        </div>
    );
}
